export const APP_LIST = [{
    title: '临床应用',
    subtitle: '深度分析临床数据，构建疾病模型，辅助临床决策，提高诊疗效率',
    img: require("@/assets/images/pic1.png"),
    icon: 'icon-application',
    size: '98px',
    marginTop: '28px',
}, {
    title: '科学研究',
    subtitle: '处理真实世界数据，发掘基础生物学知识，建立真实世界数据疾病模型',
    img: require("@/assets/images/pic2.png"),
    icon: 'icon-research',
    size: '100px',
    marginTop: '26px',
}, {
    title: '药物研发',
    subtitle: '综合真实用药数据，分析药效和受益群体，缩短新药研发周期，降低研发成本',
    img: require("@/assets/images/pic3.png"),
    icon: 'icon-medicine',
    size: '93px',
    marginTop: '33px',
}, {
    title: '数据挖掘',
    subtitle: '专有疾病数据模型，深度挖掘数据价值，致力基础科研和队列研究',
    img: require("@/assets/images/pic4.png"),
    icon: 'icon-ai',
    size: '100px',
    marginTop: '26px',
}];

export const PEOPLE = [{
    name: '陈润生',
    brife: ['中科院院士', '中科院生物物理所研究员'],
    avatar: require("@/assets/images/people/chen.png"),
    detail: [
        '主要研究集中在基因功能标注、生物进化、SNP数据分析、生物网络、非编码区基因调控和表达等方面。',
    ],
}, {
    name: '王永雄',
    brife: ['国际统计学和生物信息学界著名科学家、三院院士', '斯坦福大学统计系主任及教授'],
    avatar: require("@/assets/images/people/wang.png"),
    // open: false,
    detail: [
        '在基因表达调控、肿瘤的早期检测等方面有丰富的开发产业转化经验。',
    ],
}, {
    name: '刘小乐',
    brife: ['哈佛大学终身教授', 'Dana-Farber肿瘤研究所功能性癌症表观遗传组学中心主任'],
    avatar: require("@/assets/images/people/liu.png"),
    detail: [
        '侧重研究基因调控和计算生物学，以及转录与表观遗传调控的计算和统计模型。',
    ],
}, {
    name: '李蔚',
    brife: ['美国贝勒医学院教授'],
    avatar: require("@/assets/images/people/li.png"),
    detail: [
        '主要研究集中在开发和应用生物信息学基础算法，用以阐明基因突变、表观遗传等机制在正常发育、疾病发生中的意义。',
    ],
}, {
    name: '何新军',
    brife: ['医基云医疗数据研究院', '执行院长'],
    avatar: require("@/assets/images/people/he.png"),
    detail: [
        '本科毕业于清华大学生物系，美国俄勒冈大学生物学博士，并于美国哈佛大学和南加州大学深造。多年来专注于基因数据分析，致力于基因数据和临床数据的融合和深度数据挖掘。',
    ],
}];

export const COOPERATIONS = [{
    img: require("@/assets/images/cooperation/co1.png"),
    width: '18.99%',
}, {
    img: require("@/assets/images/cooperation/co2.png"),
    width: '18.99%',
    marginLeft: '2.6%',
// }, {
//     img: require("@/assets/images/cooperation/co3.png"),
//     width: '14.76%',
//     marginLeft: '1.58%',
}, {
    img: require("@/assets/images/cooperation/co4.png"),
    width: '10.77%',
    marginLeft:  '3.99%',
}, {
    img: require("@/assets/images/cooperation/co5.png"),
    width: '23.24%',
    marginLeft: '5.07%',
}];

export const FUNCTIONS = [{
    title: [
        '整合多维数据',
        '服务精准医疗',
    ],
}, {
    title: [
        '基于临床数据和基因数据',
        '辅助疾病诊疗',
    ],
}, {
    title: [
        '掌握患者治疗终点',
        '指导临床用药',
    ],
}, {
    title: [
        '监测不良反应',
        '掌握药物疗效',
    ],
}];
